const SubscriptionUsageIcon = ({ size = 24, color = '#899CBD', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M8.33325 15L8.33325 5"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
            />
            <path
                d="M5 15L5 9.16667"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M11.6667 15L11.6667 8.33333"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M15 15L15 11.6667"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default SubscriptionUsageIcon
